import * as channelRoutines from './channelRoutines';
import { connect } from 'react-redux';
import { getActiveEventName } from '../Events/selectors';
import { makeSortedChannelsByIndex } from './channelsSelectors';
import { setChannelActive, setChannelEditing } from '../../redux/ui/actions';
import ChannelsList from '../../Components/Channels/ChannelsList';

const mapState2Props = (state: any) => {
    return {
        active_channel_id: state.ui.activeChannel,
        channels: makeSortedChannelsByIndex(state),
        event_name: getActiveEventName(state),
    };
};
const mapDispatchToProps = {
    removeChannel: channelRoutines.removeChannel,
    reorderChannels: channelRoutines.reorderChannels,
    setChannelActive,
    setChannelEditing,
    syncChannelMessages: channelRoutines.syncChannelMessages,
    syncChannels: channelRoutines.syncChannels,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(ChannelsList);
